import { render, staticRenderFns } from "./ProductRetouching.vue?vue&type=template&id=083c6df2&scoped=true"
import script from "./ProductRetouching.vue?vue&type=script&lang=js"
export * from "./ProductRetouching.vue?vue&type=script&lang=js"
import style0 from "./ProductRetouching.vue?vue&type=style&index=0&id=083c6df2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "083c6df2",
  null
  
)

export default component.exports